import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyAccordionContainer = () => {
  return <PropertyDetail type="accordion" />;
};

export default PropertyAccordionContainer;
